import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux';
import WrappedModal from '@/components/WrappedDrawer'
import CardServiceAlertsForm from './CardServiceAlertsForm'

class CardServiceAlertsModal extends React.Component {

  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (form) => {

  }

  render () {
    const { children, baseProps, title } = this.props
    const baseComponent = (
      <CardServiceAlertsForm/>
    );
    console.log("modalProps", baseProps)
    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title}
        width={800}
        onOk={this.handleOk}
        centerTitle
        className={`center-title-modal`}
      />
    )
  }
}
// 使用函数组件作为wrapper来使用React Redux Hooks，然后传递给类组件
const VisualDashboardWrapper = (props) => { // 接收所有props
  const dispatch = useDispatch();
  // 修复数据选择逻辑
  const enhancedProps = {
    dispatch,
    ...props // 传递所有接收到的props，包括children
  }
  return <CardServiceAlertsModal {...enhancedProps}/>;
};

export default VisualDashboardWrapper;


